import { trackPromise } from 'react-promise-tracker';
import api from '../../../../utils/API';
import {
  CreateMonitoramentoBody,
  GetMonitoramentosParams,
  MonitoramentoBigNumbers,
  MonitoramentoConsumoContratoPageResponse,
  MonitoramentoDetalheDTO,
  MonitoramentoDTO,
  MonitoramentoFiltroCampo,
  MonitoramentoFiltroResponse,
  MonitoramentoMembro,
  MonitoramentoPageResponse,
} from './types';

export const getMonitoramentos = ({ page, size, ...body }: GetMonitoramentosParams): Promise<{ data: MonitoramentoPageResponse }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/listar`,
      method: 'POST',
      params: { page, size },
      data: body,
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const createMonitoramento = (body: CreateMonitoramentoBody): Promise<{ data: MonitoramentoDetalheDTO }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos`,
      method: 'POST',
      data: body,
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const updateMonitoramento = (id: number, body: CreateMonitoramentoBody): Promise<{ data: MonitoramentoDetalheDTO }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}`,
      method: 'PUT',
      data: body,
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const getMonitoramentoDetalhe = (id: number): Promise<{ data: MonitoramentoDetalheDTO }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}`,
      method: 'GET',
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

// TODO: dívida técnica — usando PUT em vez de PATCH, confirmado com o backend (mesma rota /status, mesmo body
// { ativo }), porque o CORS bloqueia PATCH nesse endpoint (Access-Control-Allow-Methods não libera PATCH).
// Voltar pra PATCH assim que o CORS for corrigido.
export const patchMonitoramentoStatus = (id: number, ativo: boolean): Promise<{ data: MonitoramentoDTO }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}/status`,
      method: 'PUT',
      data: { ativo },
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const deleteMonitoramento = (id: number): Promise<{ data: void }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}`,
      method: 'DELETE',
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

// RN1 — endpoint não tem busca por texto, só paginação (size grande + filtro no cliente no CompartilhamentoForm).
export const getMonitoramentosConsumoContrato = (page = 0, size = 200): Promise<{ data: MonitoramentoConsumoContratoPageResponse }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/consumo-contrato`,
      method: 'GET',
      params: { page, size },
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const getMonitoramentoMembros = (id: number): Promise<{ data: MonitoramentoMembro[] }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}/membros`,
      method: 'GET',
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const addMonitoramentoMembros = (id: number, emails: string[]): Promise<{ data: MonitoramentoMembro[] }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}/membros`,
      method: 'POST',
      data: { emails },
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const removeMonitoramentoMembro = (id: number, email: string): Promise<{ data: void }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}/membros/${encodeURIComponent(email)}`,
      method: 'DELETE',
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

// "Remover para mim" (RN8) — sem e-mail no path, age sobre o vínculo do usuário logado com esse monitoramento.
export const removeMonitoramentoCompartilhamento = (id: number): Promise<{ data: void }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/${id}/compartilhamento`,
      method: 'DELETE',
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const getUltimaExecucao = (): Promise<{ data: { ultimaExecucao: string } }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/ultima-execucao`,
      method: 'GET',
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const getMonitoramentosBigNumbers = (): Promise<{ data: MonitoramentoBigNumbers }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/big-numbers`,
      method: 'GET',
      expectToken: true,
    }),
    'central-de-monitoramento',
  );

export const searchMonitoramentosFiltro = <T>(
  campo: MonitoramentoFiltroCampo,
  query: string,
  size = 20,
): Promise<{ data: MonitoramentoFiltroResponse<T> }> =>
  trackPromise(
    api({
      url: `${process.env.REACT_APP_ISA_MONITORING_ENGINE_URL}/monitoramentos/filtros`,
      method: 'POST',
      params: { campo, page: 0, size },
      data: { query },
      expectToken: true,
    }),
    'central-de-monitoramento',
  );
